export const capitalize = (string) => {
	return string.charAt(0).toUpperCase() + string.slice(1)
}

export const formatAddress = ({ address, city, state, zip }) => {
	const fullAddress = []
	if (address) { fullAddress.push(capitalize(address)) }
	if (city) { fullAddress.push(capitalize(city)) }
	if (state) { fullAddress.push(capitalize(state)) }
	if (zip) { fullAddress.push(zip) }
	return fullAddress.join(', ')
}

export default formatAddress
